import { getI18N, useLocalisation } from '@3plearning/lingui-cdn';
import { t } from '@lingui/macro';
import Resources from './resources';
import {
    ACTIVITY_MASTERY,
    ALL_CLASSES,
    ALL_YEARS,
    LIVE_MATHS,
    NUM_ACTIVITIES,
    PARTICIPATION,
    RESULTS,
    SKILL_QUESTS_MASTERY,
    TEACHERS,
    TOPICS,
    ACTIVITIES,
    ACTIVITY,
    ATTEMPTS,
    LEVEL,
    LEVEL_LOWERCASE
} from '../components/report-filters/filter-constants';

export const getLocallyAcquiredI18N = (callback = () => {}) => {
    Resources.getConfigurationItem('LocalisationCdnBaseUrl').then(
        (linguiCdnBaseUrl) => {
            const locales = localeCode();

            getI18N(linguiCdnBaseUrl, [locales]).then((i18n) => {
                callback(i18n);
                return i18n;
            });
        }
    );

    return false;
};

export function localeCode() {
    const query = window.location.search.slice(1);
    const match = query.match(/\blocale=([-a-zA-Z]+)\b/);
    return match ? match[1] : 'en-AU';
}

export const translate = (translationKey) => window.i18n._(translationKey);

export const getTranslationKey = (name) => {
    if (name) {
        switch (name) {
            case PARTICIPATION:
                return 'Table Header - Participation';
            case SKILL_QUESTS_MASTERY:
                return 'Table Header - Skill Quests Mastery';
            case LIVE_MATHS:
                return 'Table Header - Live Mathletics';
            case ACTIVITY_MASTERY:
                return 'Table Header - Activity Mastery';
            case NUM_ACTIVITIES:
                return 'Label - NumActivities';
            case ALL_CLASSES:
                return 'Table Config - All classes';
            case RESULTS:
                return 'Table Config - Results';
            case ALL_YEARS:
                return 'Export - All years';
            case TEACHERS:
                return 'Label - Teachers';
            case TOPICS:
                return 'Table Config - Topics';
            case ACTIVITIES:
                return 'Table Config - Activities';
            case ACTIVITY:
                return 'Table Config - Activity';
            case ATTEMPTS:
                return 'Header - Attempts';
            case LEVEL:
                return 'Column Header - Level';
            case LEVEL_LOWERCASE:
                return 'Column Header - LevelLowercase';
            default:
                return null;
        }
    }
    return null;
};

export const useLokalise = () => {
    const { i18n } = useLocalisation();
    const teacherNumTitle = (num) => i18n._(t`Label - NumTeachers ${num}`);

    return {
        teacherNumTitle
    };
};

export const translateTableLabels = (
    tableConfig,
    translateTransform = false
) => {
    const { i18n } = useLocalisation();
    function translateName(col) {
        if (col.doTranslation) {
            col.name = i18n._(col.name);
            if (translateTransform) {
                const transformName = i18n._(col.transform());
                col.transform = () => transformName;
            }
        }
    }
    const { cols, colGroups, emptyDataMessage, nestedData } = tableConfig;
    cols.forEach((col) => translateName(col));
    if (colGroups && colGroups.length > 0) {
        colGroups[0].forEach((col) => translateName(col));
    }
    if (emptyDataMessage) {
        tableConfig.emptyDataMessage = i18n._(emptyDataMessage);
    }
    if (nestedData) {
        if (nestedData.emptyDataMessage) {
            nestedData.emptyDataMessage = i18n._(nestedData.emptyDataMessage);
        }
        const { cols: nestedDataCols } = nestedData;
        nestedDataCols.forEach((col) => translateName(col));
    }
    return tableConfig;
};



// WEBPACK FOOTER //
// ./helpers/locale-helpers.js